var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOpportunities02 = function SvgOpportunities02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,10c-0.1,0-0.1,0-0.2,0l1.1,1.1c0.4,0.5,0.4,1.3,0,1.7c-0.2,0.2-0.5,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.8-0.3 L10,11.8c0,0.1,0,0.1,0,0.2c0,1.1,0.9,2,2,2s2-0.9,2-2C14,10.9,13.1,10,12,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0c-2,0-4,0.5-5.7,1.4L8,3.3v0.6C9.2,3.3,10.6,3,12,3c5,0,9,4,9,9c0,5-4,9-9,9s-9-4-9-9c0-1.4,0.3-2.8,0.9-4 H3.3L1.4,6.3C0.5,8,0,9.9,0,12c0,6.6,5.4,12,12,12s12-5.4,12-12C24,5.4,18.6,0,12,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,5c-1.4,0-2.7,0.4-3.8,1.1l2.1,2.3C10.8,8.1,11.4,8,12,8c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4s-4-1.8-4-4 c0-0.6,0.1-1.2,0.4-1.7L6.1,8.2C5.4,9.3,5,10.6,5,12c0,3.9,3.1,7,7,7s7-3.1,7-7C19,8.1,15.9,5,12,5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,4L4,3.5V0.3l3,3.4v2.7l5.2,5.5c0.1,0.1,0.1,0.2,0,0.3v0c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2-0.1L6.3,7 H3.7L0.3,4H3.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpportunities02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/opportunities02.92aed242.svg";
export { ForwardRef as ReactComponent };